export const worker = `
import { bootstrapWorker } from '@vendure/core'
import { config } from './vendure-config'

/**
 * Bootstrap the Vendure worker process
 * 
 * The worker process handles background jobs such as:
 * - Email sending
 * - Search index updates
 * - Product variant generation
 * - Asset processing
 * - Custom plugin jobs
 */
async function startWorker() {
  console.log('🔄 Starting Vendure worker...')
  
  const worker = await bootstrapWorker(config)
  
  console.log('⚡ Starting job queue...')
  await worker.startJobQueue()
  
  console.log('✅ Vendure worker started successfully!')
  console.log('📋 Worker is now processing background jobs...')
}

startWorker().catch(err => {
  console.error('❌ Error starting worker:', err)
  process.exit(1)
})
`
